import { MAC_KEY_MAP, WINDOWS_KEY_MAP } from "./constants";
export var getOS = function getOS() {
  var _navigator$userAgentD, _navigator$userAgentD2;
  if (typeof navigator === "undefined") return null;
  var platform = (_navigator$userAgentD = (_navigator$userAgentD2 = navigator.userAgentData) === null || _navigator$userAgentD2 === void 0 || (_navigator$userAgentD2 = _navigator$userAgentD2.platform) === null || _navigator$userAgentD2 === void 0 ? void 0 : _navigator$userAgentD2.toLowerCase()) !== null && _navigator$userAgentD !== void 0 ? _navigator$userAgentD : null;
  if (platform !== null && platform !== void 0 && platform.includes("mac")) return "mac";
  if (platform !== null && platform !== void 0 && platform.includes("win")) return "windows";
  if (platform !== null && platform !== void 0 && platform.includes("linux")) return "linux";
  return platform;
};

/**
 * Transforms a key label to its platform-specific representation.
 *
 * @param key - The key to transform (e.g., "cmd", "ctrl", "shift")
 * @param os - The target operating system
 * @returns The platform-appropriate key label
 */
export var transformKey = function transformKey(key, os) {
  var _keyMap$normalizedKey;
  var normalizedKey = key.toLowerCase().trim();
  var keyMap = os === "mac" ? MAC_KEY_MAP : WINDOWS_KEY_MAP;
  return (_keyMap$normalizedKey = keyMap[normalizedKey]) !== null && _keyMap$normalizedKey !== void 0 ? _keyMap$normalizedKey : key;
};

/**
 * Transforms an array of keys to their platform-specific representations.
 *
 * @param keys - Array of key labels
 * @param os - The target operating system
 * @returns Array of platform-appropriate key labels
 *
 * @example
 * transformKeys(["cmd", "shift", "P"], "mac") // ["⌘", "⇧", "P"]
 * transformKeys(["cmd", "shift", "P"], "windows") // ["Ctrl", "Shift", "P"]
 */
export var transformKeys = function transformKeys(keys, os) {
  return keys.map(function (key) {
    return transformKey(key, os);
  });
};